<template>
    <text-heading>{{ title }}</text-heading>

    <div
        v-if="props.arguments"
        class="arguments"
    >
        <text-decorator size="sm" bold>
            Parameters
        </text-decorator>
        <data-group v-for="(value, key, index) in props.arguments" :key="index">
            <data-label>{{ key }}</data-label>
            <data-value>{{ value }}</data-value>
        </data-group>
    </div>

    <div
        v-if="result"
        class="result"
    >
        <text-decorator size="sm" bold>
            Resultaat
        </text-decorator>
        <div style="font-family: monospace; word-wrap: anywhere; white-space: break-spaces;">
            {{ result }}
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { Interaction } from '@keyvue/one-api-client';

    const props = defineProps<{
        title: string,
        interaction: Interaction,
        arguments: Record<string, any>,
        result: string,
    }>();
</script>

<style scoped lang="scss">
    .arguments,
    .result {
        display: grid;
        gap: size(sm);
        background-color: color(gray-100);
        padding: size(sm);
        border-radius: size(xs);
        max-width: 100%;
        box-sizing: border-box;
    }
</style>
